<template>
  <div class="container">
    <div class="text-start d-none">
      <h1 class="fw-bold">Leaderboard</h1>
    </div>

    <div class="row">
      <div
        v-for="board in leaderboardContent"
        :key="board.id"
        class="col-12 col-lg-6 mb-5"
      >
        <LeaderboardCard
          :title="`${board.title} Leaderboard`"
          :selectedTimeFilter="board.timeFilter"
          :selectedLeaderboardFilter="board.leaderboardFilter"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LeaderboardCard from "@/components/activity/LeaderboardCard.vue";
import leaderboardContent from "@/data/leaderboards.json";

export default {
  name: "LeaderboardView",
  components: { LeaderboardCard },
  data() {
    return {
      leaderboardContent
    };
  }
};
</script>
